import React, {useState, useEffect, useRef} from "react";
import { Link , useParams, useNavigate  } from "react-router-dom";
import {
	API_ENDPOINT, 
	replaceWithBr, 
	toast_anim, 
	toast_anim_error, 
	APP_URL, 
	APP_NAME,
	IMG_URL, 
	amount_format,
	discount,
	showRating,
	rating_format,
	BACKEND_URL,
	companysectionlist
} from '../components/config/Common'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import classNames from 'classnames';
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {isMobile} from "react-device-detect"
import {Helmet} from 'react-helmet-async'
import {Links} from '../routes/PathLink'
//import {useAuth} from '../provider/AuthProvider'
import { LazyLoadImage,LazyLoadComponent } from 'react-lazy-load-image-component';
import Seo from 'components/seo/seo'

import {
  useCompanyQuery
} from '../data/company';
import CompanyNavbar from 'components/company/companynavbar';
import CompanySections from 'components/company/companysections';
import {CompanyFinProvider} from "contexts/companyfindata/companyfindata.context.tsx"


const CompanyDetails = () => {	
	const navigate = useNavigate();
	
	const [product_slug, setProduct_slug] = useState('');	
	const [cat_arr, setCatArr] = useState([])	
	const [canonicalurl , setCanonicalurl] = useState('');	
	const [description, setDescription] = useState('');
	const {slug,type} = useParams()
	//const { isUser, loginToken } = useAuth();
	//const { addCartItem, cartItem, updateItemQty, deleteCartItem, checkItemInCart, itemCartQty } = useCart();
	
	const [metaTitle, setMetaTitle] = useState('')
	const [metaDesc, setMetaDesc] = useState('')
	const [user_type, setUser_type] = useState('');
    const [snipetData, setSnipetData] = useState('');
	console.log("slug",slug);
	const {
		product,
		companymainLabelsList:companymainLabelsList,
		isFollowed,
		isLoading: loading,
		error,
	} = useCompanyQuery({slug
	});

	useEffect(() => {
		if (product?.name) {
			setMetaTitle(`${product.name}`);
		}
		if(product?.symbol){
			const url=`${APP_URL}/company/${product?.symbol}`;
			setCanonicalurl(url);
		}

		if(product?.about){
			setMetaDesc(product?.about);
		}
	}, [product]);

	console.log("product",product);

	return (
		<>
		{/* <Seo 
				title={`${product?.name} - ${APP_NAME}`}
				desc={metaDesc && metaDesc.substring(0, 200)}
				url={`${APP_URL}/company/${product?.symbol}`}
			  />
			  */}
       <Helmet prioritizeSeoTags>
       	<link rel="canonical" href={canonicalurl} />
		<title>{`${metaTitle} - ${APP_NAME}`}</title>
          <meta  name="title" content={`${metaTitle} - ${APP_NAME}`}/>
          <meta  name="description" content={metaDesc && metaDesc} data-rh="true" />
          <meta property="og:type" content="website" data-rh="true" />
          <meta property="og:url" content={canonicalurl} data-rh="true" />
          <meta
			  property="og:title"
			  content={`${metaTitle} - ${APP_NAME}`}
			  data-rh="true"
			/>
			<meta
			  property="og:description"
			  content={metaDesc && metaDesc.substring(0, 200)}
			  data-rh="true"
			/>
		</Helmet> 
		<Header  />
		<CompanyFinProvider>
		{loading?
        <div className="bg-white shadow-md z-50 h-screen rounded-xl p-5">
			 <Skeleton count={30}  /> 
		</div>
		:
		<>
		{product ?
			<>			
			<CompanyNavbar companysectionlist={companysectionlist} slug={slug} companyinfo={product} />
			<CompanySections companysectionlist={companysectionlist} slug={slug} companyinfo={product} type={type} companymainLabelsList={companymainLabelsList} isFollowed={isFollowed} />	
			<Footer />
			</>
			:
			<></>
		}
		</>	
		}
		</CompanyFinProvider>
		</>
		);
};

export default CompanyDetails